/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmplifyCreditsPurchaseResponse } from '../../models/amplify-credits-purchase-response';

export interface SaveStripeAmplifyCreditsPurchaseSessionDetailsSuccess$Params {
  stripeSessionId: string;
}

export function saveStripeAmplifyCreditsPurchaseSessionDetailsSuccess(http: HttpClient, rootUrl: string, params: SaveStripeAmplifyCreditsPurchaseSessionDetailsSuccess$Params, context?: HttpContext): Observable<StrictHttpResponse<AmplifyCreditsPurchaseResponse>> {
  const rb = new RequestBuilder(rootUrl, saveStripeAmplifyCreditsPurchaseSessionDetailsSuccess.PATH, 'post');
  if (params) {
    rb.query('stripeSessionId', params.stripeSessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmplifyCreditsPurchaseResponse>;
    })
  );
}

saveStripeAmplifyCreditsPurchaseSessionDetailsSuccess.PATH = '/api/amplify-credits/save-stripe-amplify-credits-purchase-session-details-success';
